<template>
  <div class="input_normal">
    <label :for="data.id" v-html="data.label"></label>
    <input :type="data.type"
      :id="data.id" 
      :value="data.value" 
      :placeholder="data.placeholder" 
      @input="$emit('input', $event.target.value)">
  </div>
</template>

<script>
export default {
  name: 'input_normal',
  props: ['data'],
  data () {
    return {}
  }
}
</script>

<style lang="sass">
$mobile-576-media: '576px'

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

@mixin input($width: 10px,$font-size: 17px)
  height: 35px
  padding-left: 8px
  font-size: $font-size
  width: $width
  margin-top: 10px
  border: 1px solid rgb(197, 197, 197)
  border-radius: 5px
  transition: all 0.15s ease-in-out
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075)

@mixin input_focus 
  outline: none
  border-color: #66afe9
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075) ,0 0 3px 1px rgba(61, 168, 255, 0.7)

.input_normal 
  label 
    display: inline-block 
    margin-top: 10px
    font-size: 17px
    @include mobile-width
      font-size: 15px
  input 
    +input(350px)
    margin-left: 20px
    &:focus 
      +input_focus 
    @include mobile-width 
      +input(220px, 15px)
  &#comment_box
    label 
      margin-top: 30px
    textarea
      display: block
      margin-top: 10px 
      padding-left: 8px 
      width: 100%
      height: 300px
      font-size: 17px
      border: 1px solid rgb(197, 197, 197)
      border-radius: 5px
      transition: all 0.15s ease-in-out
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
      @include mobile-width 
        font-size: 15px
      &:focus 
        outline: none
        border-color: #66afe9
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075) ,0 0 3px 1px rgba(61, 168, 255, 0.7)
  &#contact_us_captcha
    input 
      width: 140px  
      @include mobile-width 
        width: 100px

.input_two
  label 
    font-size: 17px
    @include mobile-width 
      font-size: 15px
  input 
    +input
    &:focus 
      +input_focus 
    &.sm 
      width: 80px
      margin-left: 20px
      @include mobile-width 
        width: 50px
        font-size: 15px
    &.lg 
      width: 255px
      margin-left: 0
      @include mobile-width 
        width: 155px
        font-size: 15px

</style>